import { render, staticRenderFns } from "./gardesh.vue?vue&type=template&id=182ddc48"
import script from "./gardesh.vue?vue&type=script&lang=js"
export * from "./gardesh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports